import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { GradientBackground as Background } from './Background';
import { FADE, MAX_LEADERS, MODE_SOLO, MODE_AI } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { PN_BACKGROUND } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    skill: this.props.skill,
    size: this.props.size,
    score: this.props.stats ? this.props.stats.grade : 0,
  };

  componentDidMount() {
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { skill, size } = this.state;

    return this.leaders
      .where('skill', '==', skill)
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(skill, size) {
    skill = skill || this.state.skill;
    size = size || this.state.size;

    return `${this.props.app} LEADERS • ${skill} • ${size}`;
  }

  userKey() {
    let { uid, mode } = this.props;
    const { skill, size } = this.state;

    if (mode === MODE_AI) {
      mode = `${mode}-${skill}`;
    }

    mode = mode.replace('MODE ', '');

    return `${mode} • ${size} • ${uid}`;
  }

  handleSelection = (skill, size) => {
    skill = skill || this.state.skill;
    size = size || this.state.size;

    this.setState({ skill, size }, () => {
      this.getCachedLeaders(true);

      const { mode } = this.props;

      f.getStats({ mode, skill, size }, stats => {
        const grade = mode === MODE_SOLO ? f.getSoloGrade(stats.aveScore, stats.plays) : f.getDuoGrade(stats);
        this.setState({ score: grade, plays: stats.plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { skill, size, score, plays } = this.state;
    return { skill, size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const background = PN_BACKGROUND;
    const rankColor = '#f3debd';
    const dateColor = '#aa9b84';
    const submitColor = '#766c5c';
    const scoreAlias = 'Grade';
    const ai = this.props.mode === MODE_AI;
    const margin = `0 0.${ai ? 2 : 5}em`;

    return (
      <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
        {this.renderClickableScreen()}
        <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
          <div className="leaders-selector">
            {ai &&
              _.map([1, 2, 3], skill => {
                const icon = f.skillIcon(this.props, skill);
                const current = skill === this.state.skill;
                const cls = `leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                return (
                  <div key={skill} className={cls} style={{ margin: '0 0.2em' }} onClick={() => this.handleSelection(skill)}>
                    {icon}
                  </div>
                );
              })}
            {_.map([1, 2, 3, 4, 5], size => {
              const current = size === this.state.size;
              const { name: sizeName, color: background } = f.sizeInfo(size);
              const cls = `leaders-circle leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
              return (
                <div key={size + 3} className={cls} style={{ margin, background }} onClick={() => this.handleSelection(null, size)}>
                  {sizeName}
                </div>
              );
            })}
          </div>
          <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
            {_.map(this.state.users, (u, i) => (
              <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} dateColor={dateColor} scoreAlias={scoreAlias} />
            ))}
          </div>
          {this.renderCommon(rankColor, submitColor, scoreAlias)}
        </div>
      </div>
    );
  }
}

function mapStateToProps({ pn, common }) {
  return { ...pn, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
